import React, {FC} from 'react';
import styled, {css} from 'styled-components';
import {COLORS} from '../../../constants/colors';
import {mobileOnly} from '../../../constants/customMedia';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';
import {ProgressBar} from '../../atoms/ProgressBar/ProgressBar';

interface Props {
  count: number;
  label: string;
  total: number;
}

export const StreamProgress: FC<Props> = ({count, label, total, ...props}) => {
  return (
    <Wrapper data-testid="streamProgressBar" {...props}>
      <Content>
        <Title
          dangerouslySetInnerHTML={{
            __html: label,
          }}
        />

        <ProgressBar
          color={COLORS.Black}
          count={count}
          height={5}
          total={total}
        />
      </Content>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const Content = styled.div`
  width: 255px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.span`
  color: ${COLORS.Black};
  font-size: ${FONT_SIZES.px12};
  text-align: center;
  margin-bottom: 0.875rem;

  ${mobileOnly(css`
    font-size: ${FONT_SIZES.px14};
    font-weight: ${FONT_WEIGHTS.mediumBold};
    margin-bottom: 0.5rem;
  `)}

  b {
    font-weight: ${FONT_WEIGHTS.bold};
  }
`;
